/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function MergeStatusConflicts({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><mask id="MergeStatusConflicts_svg__a" width={16} height={16} x={0} y={0} maskUnits="userSpaceOnUse" style={{
      maskType: "luminance"
    }}><path fill="#fff" d="M16 0H0v16h16z" /><path fill="#000" stroke="#000" strokeLinejoin="round" strokeWidth={0.558} d="M8.415 3.865 4.28 8.825H8l-.415 3.31 4.135-4.96H8z" /></mask><g mask="url(#MergeStatusConflicts_svg__a)"><circle cx={8} cy={8} r={8} fill="currentColor" /></g></svg>;
}
;